import React, { forwardRef, useId } from 'react';

export interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ label, className = '', id, ...props }, ref) => {
    const autoId = useId();
    const radioId = id || autoId;

    return (
      <label htmlFor={radioId} className={`radio-wrapper ${className}`}>
        <input
          ref={ref}
          type="radio"
          id={radioId}
          className="radio"
          {...props}
        />
        {label && (
          <span style={{ fontFamily: 'var(--font-body)', fontSize: 'var(--text-base)' }}>
            {label}
          </span>
        )}
      </label>
    );
  }
);

Radio.displayName = 'Radio';

export default Radio;
